<script setup lang="ts">
import { VImg } from '@hatfieldmedia/hmcore'

defineProps<{
  image: string
  title: string
  description: string
  serviceType: string
}>()

defineEmits<{
  learnMore: [serviceType: string]
}>()
</script>

<template>
  <div class="svc-card" @click="$emit('learnMore', serviceType)">
    <VImg class="svc-card-img" :src="image" />
    <div class="svc-card-body">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
      <button class="link-arrow" @click.stop="$emit('learnMore', serviceType)">Learn More →</button>
    </div>
  </div>
</template>

<style scoped>
.svc-card {
  background: var(--card);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
  cursor: pointer;
  user-select: none;
}

.svc-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4);
}

.svc-card-img {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  filter: brightness(0.72);
}

.svc-card-body {
  padding: 28px;
}

h3 {
  font-family: 'HNDC', sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  color: var(--white);
  text-transform: uppercase;
  margin-bottom: 8px;
}

p {
  font-size: 0.92rem;
  line-height: 1.6;
  color: var(--text);
  margin-bottom: 16px;
}

.link-arrow {
  font-family: 'HND', sans-serif;
  font-size: 0.8rem;
  color: var(--pink-bright);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 600;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.link-arrow:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {

  .svc-card-body {
    padding: 20px;
  }

  h3 {
    font-size: 1.15rem;
  }

  p {
    font-size: 0.88rem;
  }
}

@media (max-width: 390px) {
  .svc-card-img {
    height: 180px;
  }
}
</style>
